import { Navigate, useLocation } from 'react-router-dom';
import { ReactNode } from 'react';
import { useAuth  } from '../../features/auth/hooks/useAuth';


const PublicRoute = ({ children }) => {
    const { isAuthenticated } = useAuth();
    const location = useLocation();
    
    // Si l'utilisateur est connecté, le rediriger vers le dashboard
    if (isAuthenticated) {
      // Rediriger vers la page précédente ou le dashboard par défaut
      const from = location.state?.from?.pathname || '/dashboard';
      return <Navigate to={from} replace />;
    }
    
    // Si l'utilisateur n'est pas connecté, afficher les enfants (la page de connexion)
    return <>{children}</>;
  };
  export default PublicRoute;